import interference from './interference.js'
import noise from './noise.js'

export const fields = { interference, noise }
export const fieldOptions = Object.values(fields).map((f) => ({ value: f.id, label: f.label }))
